import React, { useRef } from "react";
import { useLocation } from "react-router-dom";
import Irdashboard from "./IndentRequestDashboard/Irdashboard";
import Vtdashboard from "./IndentTrackingDashboard/Vtdashboard";
import TransitTimeDashboard from "./TransitTimeDashboard/TransitTimeDashboard";

const DashboardRouting = () => {
  const location = useLocation();
  const onRequestDashboard = location.pathname.includes("/indents/requestdashboard");
  const onTrackingDashboard = location.pathname.includes("/indents/trackingdashboard");
  const onTransitDashboard = location.pathname.includes("/indents/transittimedashboard");

  const hasRenderedRequest = useRef(false);
  const hasRenderedTracking = useRef(false);
  const hasRenderedTransit = useRef(false);
  if (onRequestDashboard) hasRenderedRequest.current = true;
  if (onTrackingDashboard) hasRenderedTracking.current = true;
  if (onTransitDashboard) hasRenderedTransit.current = true;

  return (
    <>
      {hasRenderedRequest.current && (
        <div style={{ display: onRequestDashboard ? "block" : "none" }}>
          <Irdashboard />
        </div>
      )}
      {hasRenderedTracking.current && (
        <div style={{ display: onTrackingDashboard ? "block" : "none" }}>
          <Vtdashboard />
        </div>
      )}
      {hasRenderedTransit.current && (
        <div style={{ display: onTransitDashboard ? "block" : "none" }}>
          <TransitTimeDashboard />
        </div>
      )}
    </>
  );
};

export default DashboardRouting;
